import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/mer68/Mer68_icon.png'
import { Polar75 } from '../polar75'
import { DevicePid, KK } from '@/define/define'
import { mer68VKCodes } from '../keycode/vkeycode'
import { getDeviceKeySquare } from '../keysquare/keysquare'
export class Mer68 extends Polar75 {
  name: string = 'Mer68'
  icon: string = list_icon
  width: number = 672
  square = getDeviceKeySquare(DevicePid.CarotmasMer68)
  y_number: number = 0
  vkcodes = mer68VKCodes
  fnFactoryKeys: KK[] = [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 47, 48, 4, 22, 227, 44, 230, 80, 82, 81, 79]
  customLayout: CustomLayout = {
    0x3a: this.createSquare(8),
    0x3e: this.createSquare(6),
    0x42: this.createSquare(6),
    0x46: this.createSquare(6),
    0x2a: this.createSquare(2, 2, 54),

    0x2b: this.createSquare(2, 2, 47),
    0x31: this.createSquare(2, 2, 48),
    0x39: this.createSquare(2, 2, 56),
    0x28: this.createSquare(2, 2, 82),
    0xe1: this.createSquare(2, 2, 70),
    0xe5: this.createSquare(2, 2, 68),
    0xe0: this.createSquare(2, 2, 52),
    0xe2: this.createSquare(2, 2, 52),
    0xe3: this.createSquare(2, 2, 52),
    0x2c: this.createSquare(2, 2, 214),
    0xe6: this.createSquare(2, 2, 52),
    0x01: this.createSquare(2, 2, 52),
  }
}
